package com.example.mystybag.login.views.views

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.login.logic.AddMolViewModel
import com.example.mystybag.login.views.components.MerchantRegistrationWebBoundedColumn

@Composable
fun AddMolWebView(viewModel: AddMolViewModel) {
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        horizontalAlignment = Alignment.Start
    ) { _ ->
        MerchantRegistrationWebBoundedColumn(Modifier.fillMaxSize()) {
            AddMolScreen(viewModel = viewModel, showRegistrationProgress = true)
        }
    }
}
